// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"8a636dc5","239":"9c1f6ee1","732":"9d82ae64","977":"aee5a6fe"}[chunkId] + ".chunk.js";
};